import { z } from "zod";
import { apiClient } from "../client";
import { commentSchema } from "./schemas";
import type {
  Comment,
  CreateCommentRequest,
  UpdateCommentRequest,
} from "./types";

export async function getComments(fileId: string): Promise<Comment[]> {
  const response = await apiClient
    .get("comments", { searchParams: { fileId } })
    .json<Comment[]>();

  return z.array(commentSchema).parse(response);
}

export async function getComment(id: string | number): Promise<Comment> {
  const response = await apiClient.get(`comments/${id}`, {}).json<Comment>();

  return commentSchema.parse(response);
}

export async function createComment(
  data: CreateCommentRequest
): Promise<Comment> {
  const response = await apiClient
    .post("comments", { json: data })
    .json<Comment>();

  return commentSchema.parse(response);
}

export async function updateComment(
  id: string | number,
  data: UpdateCommentRequest
): Promise<Comment> {
  const response = await apiClient
    .put(`comments/${id}`, { json: data })
    .json<Comment>();

  return commentSchema.parse(response);
}

export async function deleteComment(id: string | number): Promise<void> {
  await apiClient.delete(`comments/${id}`, {});
}
